<template>
    <div class="form">
        <ValidationObserver v-slot="{ errors, invalid, handleSubmit }" @submit.prevent>
            <h4 class="step-title">
                <label for="phoneNumber">What's your phone number?</label>
            </h4>
            <div class="step-content d-flex flex-column align-items-center">
                <div class="step-item">
                    <ValidationProvider mode="eager" vid="phoneNumber" name="Phone number" rules="required|phone">
                        <input id="phoneNumber" class="form-control min-content-width" placeholder="(xxx) xxx-xxxx" type="tel" v-on:keyup.enter="enterKeyup" v-model="lead.phoneNumber">
                    </ValidationProvider>
                </div>
                <div class="step-item">
                    <div class="alert alert-danger" v-if="errors['phoneNumber'] && errors['phoneNumber'].length > 0">{{ errors["phoneNumber"][0] }}</div>
                </div>
                <div class="step-item">
                    <ValidationProvider mode="eager" vid="leadid_tcpa_disclosure" name="consent" v-bind:rules="{ required: { allowFalse: false } }">
                        <div class="d-flex">
                            <div id="consent-wrapper">
                                <input id="leadid_tcpa_disclosure" type="checkbox" v-model="checked">
                            </div>
                            <label id="tcpa-text" for="leadid_tcpa_disclosure">
                                By clicking 'View My Quote', I expressly consent to receive marketing communications,
                                including via calls using an automatic telephone dialing system and artificial or pre-recorded messages,
                                emails, and text messages (SMS), from insurance companies or their agents, the owner of this website and its agents,
                                live operators, representatives and affiliates, and partner companies,
                                at the wireless/landline/voip telephone number {{ phoneNumberForConsent }} and email address {{ lead.email }}.
                                I am providing this express written consent notwithstanding any current or prior election on the Do Not Call registry or
                                anywhere else to opt in or opt out of receiving telemarketing calls or SMS messages from Avenge Digital LLC,
                                its agents, representatives and affiliates, and its partner companies.
                                I understand that my consent to receive communications in this manner is not required as a condition of purchasing any goods or services,
                                my telephone company may impose charges for these contacts, and I can revoke my consent at any time.
                                I further agree to the <a v-bind:href="termsAndConditionsUrl" target="_blank">Terms and Conditions</a> and <a v-bind:href="privacyPolicyUrl" target="_blank">Privacy Policy</a>.
                            </label>
                        </div>
                    </ValidationProvider>
                </div>
                <div class="step-item">
                    <div class="alert alert-danger" v-if="!submitted && errors['leadid_tcpa_disclosure'] && errors['leadid_tcpa_disclosure'].length > 0">{{ errors["leadid_tcpa_disclosure"][0] }}</div>
                </div>
                <div class="step-item" v-if="!submitted && !lead.submitted">
                    <button class="btn step-btn" ref="complete" v-on:click="handleSubmit(complete)">View My Quote</button>
                </div>
                <div class="step-item" v-if="submitted && !lead.submitted">
                    <div class="spinner-border text-light" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>
                <div class="step-item" v-if="lead.submitted">
                    <div class="alert alert-success" role="alert" v-if="lead.submittedSuccessfully">
                        Thank You! Your information has successfully been submitted.
                    </div>
                    <div class="alert alert-danger" role="alert" v-else>
                        Uh oh, there was a problem submitting your information. Please call us to get your quote.
                    </div>
                </div>
            </div>
            <SlotInvalidInputWatchComponent v-bind:invalid="invalid && checked && !submitted" v-bind:value="lead.phoneNumber" v-on:invalidInput="onInvalidInput" />
        </ValidationObserver>
    </div>
</template>

<script>
    import { extend } from 'vee-validate';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { required } from "vee-validate/dist/rules";
    import PhoneNumber from 'awesome-phonenumber'
    import SlotInvalidInputWatchComponent from "./shared/SlotInvalidInputWatchComponent.vue";

    extend("required", {
        ...required,
        message: "{_field_} is required."
    });

    extend("phone", {
        message () {
            return "Invalid phone number.";
        },
        validate (value) {
            return new Promise(resolve => {
                // add country code
                if (value.indexOf("+1") < 0) {
                    value = "+1" + value;
                }
                var phoneNumber = new PhoneNumber(value);
                resolve({ valid: phoneNumber.isValid() })
            });
        }
    });

    export default {
        name: "PhoneNumber",
        components: {
            ValidationProvider,
            ValidationObserver,
            SlotInvalidInputWatchComponent
        },
        data: function() {
            return {
                checked: false,
                submitted: false
            }
        },
        props: {
            lead: Object
        },
        computed: {
            termsAndConditionsUrl: function() {
                return this.appConfig.termsAndConditionsUrl;
            },
            privacyPolicyUrl: function() {
                return this.appConfig.privacyPolicyUrl;
            },
            partnersUrl: function() {
                return this.appConfig.partnersUrl;
            },
            phoneNumberForConsent: function() {
                if (this.validatePhoneNumber(this.lead.phoneNumber)) {
                    return this.lead.phoneNumber;
                }

                return "(xxx) xxx-xxxx";
            }
        },
        methods: {
            validatePhoneNumber: function(value) {
                if (!value) {
                    return false;
                }

                // add country code
                if (value.indexOf("+1") < 0) {
                    value = "+1" + value;
                }
                var phoneNumber = new PhoneNumber(value);
                return phoneNumber.isValid();
            },
            enterKeyup: function() {
                this.$refs.complete.click();
            },
            complete: function() {
                this.$emit("complete", this.$options.name, this.lead.phoneNumber);
                this.submitted = true;
            },
            onInvalidInput: function(value) {
                this.utils.log("onInvalidInput: " + value);
                this.$emit("invalidInput", this.$options.name, value);
            }
        }
    }
</script>

<style scoped>

#consent-wrapper {
    margin: .5rem !important;
}

#leadid_tcpa_disclosure {
    transform: scale(1.5);
}

#tcpa-text {
    color: white;

    text-align: left;

    /* make sure scrollbar doesn't overlap text */
    margin-right: 1rem !important;


    /* fix for tiny checkbox on mobile safari */
    flex: 1;
}

#tcpa-text a {
    color: white;
    text-decoration: underline;
}

</style>
